module.exports = __webpack_public_path__ + "img/1540531378.63b248f7.jpg";